module.exports = __webpack_public_path__ + "img/img_captacion.47a7f3ff.png";